import { c as _c } from "react/compiler-runtime";
import { Badge, StarRating } from '@petsmart-ui/sparky';
import { decodeEntityString } from '@libs/algolia';
import { encodeFref, type FrefListCodes } from '@libs/common-next';
import { type BuyItAgainItem } from '@libs/common-types';
import { useSelectProductEvent, useTrackProduct } from '../../hooks';
import { Price } from './components';
import './carousel-product-card.scss';
export type CarouselProductCardProps = {
  recommendation: BuyItAgainItem;
  /**
   * Where this card actually shows up in the row, counting from 1.
   * Not the same as `recommendationRank`. Some products get filtered out before we render.
   */
  position: number;
  frefAttribution: FrefListCodes;
  onView?: () => void;
};
export const CarouselProductCard = t0 => {
  const $ = _c(40);
  const {
    recommendation,
    position,
    frefAttribution,
    onView
  } = t0;
  let t1;
  if ($[0] !== frefAttribution || $[1] !== position) {
    t1 = {
      position,
      frefAttribution
    };
    $[0] = frefAttribution;
    $[1] = position;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const sendSelectEvent = useSelectProductEvent(recommendation, t1);
  const {
    name,
    url,
    image,
    price,
    rating,
    badges,
    unitsPurchasedLast24Months: purchasedTimes
  } = recommendation;
  let t2;
  if ($[3] !== name) {
    t2 = decodeEntityString(name);
    $[3] = name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const title = t2;
  const badgeText = badges?.[0];
  let t3;
  if ($[5] !== frefAttribution || $[6] !== position) {
    t3 = encodeFref({
      ...frefAttribution,
      index: position
    });
    $[5] = frefAttribution;
    $[6] = position;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const frefQuery = t3;
  const href = `${url}${url.includes("?") ? "&" : "?"}${frefQuery}`;
  let t4;
  if ($[8] !== onView || $[9] !== recommendation) {
    t4 = {
      product: recommendation,
      onView
    };
    $[8] = onView;
    $[9] = recommendation;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    ref
  } = useTrackProduct(t4);
  let t5;
  if ($[11] !== href || $[12] !== sendSelectEvent || $[13] !== title) {
    t5 = <h3 className="carousel-product-card__title"><a href={href} className="carousel-product-card__text-link" onClickCapture={sendSelectEvent}>{title}</a></h3>;
    $[11] = href;
    $[12] = sendSelectEvent;
    $[13] = title;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== image || $[16] !== title) {
    t6 = <img className="carousel-product-card__image" src={image} alt={title} aria-hidden="true" />;
    $[15] = image;
    $[16] = title;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const t7 = purchasedTimes === 1 ? "time" : "times";
  let t8;
  if ($[18] !== purchasedTimes || $[19] !== t7) {
    t8 = <span className="carousel-product-card__meta">Purchased {purchasedTimes} {t7}</span>;
    $[18] = purchasedTimes;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t5 || $[22] !== t6 || $[23] !== t8) {
    t9 = <div className="carousel-product-card__header">{t5}{t6}{t8}</div>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== badgeText) {
    t10 = badgeText && <Badge className="sparky-c-product-card__badge" text={badgeText} aria-hidden="true" />;
    $[25] = badgeText;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== rating.average || $[28] !== rating.count) {
    t11 = rating.average !== undefined && <div className="rating"><span className="visually-hidden">{`${rating.average} out of 5 stars selected ${rating.count} reviews`}</span><StarRating className="sparky-c-product-card__star-rating" value={rating.average} ratingAfter={`(${rating.count})`} size="sm" aria-hidden="true" /></div>;
    $[27] = rating.average;
    $[28] = rating.count;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== price) {
    t12 = price && <div className="price"><Price price={price} /></div>;
    $[30] = price;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t12) {
    t13 = <div className="carousel-product-card__footer">{t10}{t11}{t12}</div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== ref || $[37] !== t13 || $[38] !== t9) {
    t14 = <div className="carousel-product-card" data-testid="product-carousel-item" ref={ref}>{t9}{t13}</div>;
    $[36] = ref;
    $[37] = t13;
    $[38] = t9;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
};